import {Button, Dropdown, Form, InputGroup} from "react-bootstrap";
import React from "react";
import {Field} from "formik";
import {toggleDays} from "../../../utils2";

export function SetWeekly({value, options, selected, onSelect, onClear, disabled}) {
    return <InputGroup className="flex-nowrap">
        <Button variant="outline-secondary" onClick={onClear} disabled={disabled}><i className="bi bi-x-lg"/></Button>

        {/*<Button variant={`${selected ? "primary" : "outline-primary"}`} className="flex-grow-1" disabled={disabled}>*/}
        {/*    {selected ? selected.long : value}*/}
        {/*</Button>*/}

        <Dropdown onSelect={onSelect}>
            <Dropdown.Toggle variant={`${selected ? "primary" : "outline-primary"}`} disabled={disabled} className="flex-grow-1">
                {selected ? selected.long : value}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {options.map(o => (
                    <Dropdown.Item key={o.id} eventKey={o.id} active={o.id === selected?.id}>{o.long}</Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>

    </InputGroup>
}

export function SetWeeklyField({name, value, disabled, props}) {
    return <>
        <Field name={name}>
            {({field, meta, form}) => <Form.Group controlId={name + "Id"} className="flex-grow-1" {...props}>
                <InputGroup hasValidation>

                    <Form.Select {...field} isInvalid={meta.touched && !!meta.error} disabled={disabled}>
                        <option disabled value="">{value || "Select a day"}</option>
                        {toggleDays.map(item => (
                            <option key={item.id} value={item.id}>{item.long}</option>
                        ))}
                    </Form.Select>

                    <Button variant="outline-secondary" disabled={disabled} onClick={() => form.setFieldValue(name, "")}><i className="bi bi-x-lg"/></Button>

                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                </InputGroup>

            </Form.Group>}
        </Field>
    </>
}